<div class="balance-change-indicator balance-change-indicator--{{direction}}">
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 20L0.741669 0.5L23.2583 0.5L12 20Z" />
    </svg>
</div>
